<template>
  <div
    class="story-card"
    style="width: 400px"
  >
    <v-col>
      <MediaItem
        :item="mediaItem"
        :mediaType="mediaType"
        :videoThumbnail="videoThumbnail"
        :height="302"
        :width="170"
        :aspectRatio="9 / 16"
        @input="uploadFile($event, 'media', storyItem.id)"
      />
      <v-text-field
        v-model="storyItem.button_text"
        class="mb-3 mt-5"
        dense
        hide-details
        label="Текст кнопки"
        outlined
      />
      <TextFieldColor v-model="storyItem.button_color" />
      <LinkType :item="storyItem" />
    </v-col>
  </div>
</template>

<script>
  import MediaItem from './MediaItem.vue'
  import TextFieldColor from '@/admin/components/TextFieldColor.vue'
  import LinkType from '@/admin/components/LinkType.vue'
  import { MediaType } from '@/airModels/types/mediaTypes.js'

  export default {
    name: 'StoryItem',
    components: { MediaItem, TextFieldColor, LinkType },
    props: {
      storyItem: Object
    },

    data: () => {
      const mediaTypesName = {
        [MediaType.IMAGE]: 'image',
        [MediaType.VIDEO]: 'video'
      }
      return {
        outletsDialog: false,
        searchValue: null,
        selectedFile: null,
        mediaItemSource: null,
        videoThumbnail: null,
        mediaTypesName
      }
    },
    mounted() {
      if (this.mediaType === MediaType.VIDEO) {
        this.generateThumbnail(this.storyItem.video).then(res => {
          this.videoThumbnail = res.url
        })
      }
    },
    computed: {
      mediaItem() {
        if (!this.storyItem.id) {
          return this.mediaItemSource
        }
        return this.mediaType === MediaType.IMAGE ? this.storyItem.image : this.storyItem.video
      },
      mediaType: {
        get() {
          return this.storyItem.media_type ?? MediaType.IMAGE
        },
        set(v) {
          this.storyItem.media_type = v
        }
      }
    },
    methods: {
      async generateThumbnail(videoUrl, time = 1) {
        return new Promise((resolve, reject) => {
          console.log(videoUrl)
          const video = document.createElement('video')
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          video.crossOrigin = 'anonymous'

          video.onerror = () => reject(new Error('Ошибка загрузки видео'))

          video.onloadedmetadata = () => {
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight
            video.currentTime = Math.min(time, video.duration)
          }

          video.onseeked = () => {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
            canvas.toBlob(
              blob => {
                if (blob) {
                  const thumbnailUrl = URL.createObjectURL(blob)
                  resolve({
                    blob,
                    url: thumbnailUrl,
                    width: canvas.width,
                    height: canvas.height
                  })
                } else {
                  reject(new Error('Не удалось создать blob'))
                }
              },
              'image/jpeg',
              1.0
            )
          }

          video.src = videoUrl
          setTimeout(() => {
            reject(new Error('Таймаут генерации превью'))
          }, 10000)
        })
      },
      async uploadFile(file, field, id) {
        if (file.type.startsWith('video/')) {
          this.mediaType = MediaType.VIDEO
        } else {
          this.mediaType = MediaType.IMAGE
        }

        this.selectedFile = file

        if (!id) {
          const reader = new FileReader()
          reader.readAsDataURL(file)

          reader.onload = () => {
            if (this.mediaType === MediaType.VIDEO) {
              const localVideoUrl = URL.createObjectURL(file)
              this.generateThumbnail(localVideoUrl).then(res => {
                this.videoThumbnail = res.url
                this.mediaItemSource = localVideoUrl
              })
            } else {
              this.mediaItemSource = reader.result
            }
          }
        } else {
          const formData = new FormData()
          formData.append(this.mediaTypesName[this.mediaType], file)
          formData.append('media_type', this.mediaType)

          const res = await this.$promo.sendPutSingle(
            `story-slides/${id}/upload-media`,
            this.$promo.item.id,
            formData
          )

          const slide = res.story_slides[this.storyItem.position]
          if (this.storyItem.media_type == MediaType.IMAGE) {
            this.storyItem.image = slide.image
            this.videoThumbnail = null
          } else {
            this.storyItem.video = slide.video
            this.generateThumbnail(slide.video).then(res => {
              this.videoThumbnail = res.url
            })
          }

          this.selectedFile = null
        }
      },
      afterSave(item) {
        console.log(`story item id ${item.id}`)
        if (item.id && this.selectedFile !== null) {
          this.uploadFile(this.selectedFile, 'media', item.id)
        }
      }
    }
  }
</script>

<style scoped>
  .story-card {
    border: 1.5px solid #e0e0e0;
    border-radius: 16px;
    padding: 8px;
    background: white;
  }
</style>
